var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisible)?_c('div',{staticClass:"errorvue"},[_c('div',{staticClass:"errorTip"},[_c('div',{staticClass:"remove_him"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }